module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-left/icon-arrow-left-9292569267306758f4b33f262ae9379a.svg";